import React from 'react';
import PropTypes from 'prop-types';
import { get, groupBy } from 'lodash-es';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { TcoEntities } from 'client/data/models/cost-to-own';
import { validation } from 'site-modules/shared/components/form-validation/validation';
import { StyledSelect } from 'site-modules/shared/components/styled-select/styled-select';
import { ZipInput } from 'site-modules/shared/components/zip-input/zip-input';

export const getZipInputTracking = () => ({ 'data-tracking-id': 'zip_input' });

export function SelectionSection({ styles, tcoStylesData, selectedStyleId, onStyleSelect }) {
  const groupedOptions = groupBy(
    styles.map(style => {
      const disabled = !get(tcoStylesData, `["${style.id}"].totalCash`);

      return {
        ...style,
        label: `${style.name}${disabled ? ' - Data Unavailable' : ''}`,
        disabled,
      };
    }),
    'submodels.name'
  );

  return (
    <Row className="selection-section mb-1_5">
      <StyledSelect
        value={selectedStyleId}
        optionsGrouped={groupedOptions}
        onChange={onStyleSelect}
        name="select-style"
        valueKey="id"
        labelKey="label"
        labelText="Select Model"
        labelClassName="label d-block mb-0_5"
        className="form-control py-0_5 size-16"
        wrapperClassName="col-xs-12 col-md-9"
      />
      <Col xs={4} md={3}>
        <ZipInput
          label="Near ZIP"
          inputAriaLabel="Near ZIP"
          wrapperClasses="mt-1 mt-md-0"
          labelClasses="label d-block mb-0_5"
          inputClasses="form-control size-16"
          onValidate={validation.validateZip}
          getTracking={getZipInputTracking}
        />
      </Col>
    </Row>
  );
}

SelectionSection.propTypes = {
  styles: VehicleEntities.Styles.isRequired,
  tcoStylesData: PropTypes.objectOf(TcoEntities.StyleTco).isRequired,
  onStyleSelect: PropTypes.func.isRequired,
  selectedStyleId: PropTypes.number.isRequired,
};
